module.exports = __webpack_public_path__ + "img/bubblingstream.89ecb838.png";